import {
  MapaGerenciamentoVeiculo,
  MapaMotoristasEmViagem,
} from '@sotran/lib-shipper';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import SubHeader from '../../components/SubHeader';
import { useAuth } from '../../security/authContext';
import apiAts from '../../services/apiATS';
import apiNetCore from '../../services/apiNetCore';
import { Tabs } from '../../styles/global';
import { Card } from './styles';

const { TabPane } = Tabs;

export default function MapaGerenciamento() {
  const { user } = useAuth();
  const { search } = useParams();

  const [currentTab, setCurrentTab] = useState(1);
  const [isSearchIdlote, setIsSearchIdLote] = useState(false);
  const [isSearchCidade, setIsSearchCidade] = useState(false);

  useEffect(() => {
    if (search) {
      if (Number(search)) {
        setCurrentTab(2);
        setIsSearchIdLote(true);
      } else {
        setCurrentTab(1);
        setIsSearchCidade(true);
      }
    }
  }, [search]);

  const tabs = [
    {
      key: '1',
      title: 'Motoristas na região',
      content: (
        <MapaGerenciamentoVeiculo
          apiAts={apiAts}
          apiNetCore={apiNetCore}
          isUsuarioSotran={user.profile === 'SOTRAN'}
          search={isSearchCidade ? search : ''}
          mapHeight="60vh"
        />
      ),
    },
    {
      key: '2',
      title: 'Motoristas em viagem',
      content: (
        <MapaMotoristasEmViagem
          apiAts={apiAts}
          apiNetCore={apiNetCore}
          isUsuarioSotran={user.profile === 'SOTRAN'}
          clientesPagadores={user.clientes_pagadores || []}
          search={isSearchIdlote ? search : ''}
          mapHeight="60vh"
        />
      ),
    },
  ];

  const breadcrumbs = [
    {
      breadcrumbName: tabs[currentTab - 1].title,
    },
  ];

  const onTabClickChange = value => setCurrentTab(Number(value));

  return (
    <>
      <SubHeader breadcrumbs={breadcrumbs} />
      <Card bordered={false} className="pt-10 height-85">
        <Tabs activeKey={currentTab.toString()} onTabClick={onTabClickChange}>
          {tabs.map(item => (
            <TabPane tab={item.title} key={item.key}>
              {item.content}
            </TabPane>
          ))}
        </Tabs>
      </Card>
    </>
  );
}
